/**
 * @packageDocumentation
 * @module Sidenav
 * @category Core
 */
import { Models } from '@adm/casl';

import { SidenavItem } from './sidenav-item.model';

/**
 * Массив всех возможных элементов бокового меню.
 *
 * @group Consts
 */
export const SIDENAV_MENU_ITEMS: SidenavItem[] = [
  new SidenavItem({
    svgIcon: 'person',
    name: 'MENU.CUSTOMERS',
    route: '',
    subItems: [
      new SidenavItem({
        svgIcon: 'point',
        name: 'MENU.CUSTOMER_LIST',
        route: '/customers',
        subject: [Models.Customers],
        position: 0,
      }),
      new SidenavItem({
        svgIcon: 'point',
        name: 'MENU.OWNERSHIPS',
        route: '/ownerships',
        subject: [Models.Ownerships],
        position: 1,
      }),
    ],
    subject: [Models.Customers, Models.Ownerships],
    position: 1,
  }),
  new SidenavItem({
    svgIcon: 'car',
    name: 'MENU.VEHICLES',
    route: '',
    position: 2,
    subject: [Models.Vehicles, Models.Devices],
    subItems: [
      new SidenavItem({
        svgIcon: 'point',
        name: 'MENU.VEHICLES_LIST',
        route: '/vehicles',
        position: 0,
        subject: [Models.Vehicles],
      }),
      new SidenavItem({
        svgIcon: 'point',
        name: 'MENU.TELEMATIC_BLOCKS',
        route: '/telematics-blocks',
        position: 1,
        subject: [Models.Devices],
      }),
    ],
  }),
  new SidenavItem({
    svgIcon: 'filter',
    name: 'MENU.CONFIGURATOR',
    route: '/configurator',
    position: 3,
    subject: [Models.Configurations, Models.Brands, Models.Colors],
  }),
  new SidenavItem({
    svgIcon: 'i-documents-accepted',
    name: 'MENU.TICKETS',
    route: '',
    position: 5,
    subject: [Models.Tickets],
    subItems: [
      new SidenavItem({
        svgIcon: 'point',
        name: 'MENU.VEHICLES_ADD',
        route: '/ticket-car',
        position: 1,
        subject: [Models.Tickets],
      }),
    ],
  }),
  new SidenavItem({
    svgIcon: 'devices',
    name: 'MENU.DEVICES',
    route: '',
    position: 4,
    subject: [Models.BatchFirmwareUpdate],
    subItems: [
      new SidenavItem({
        svgIcon: 'point',
        name: 'MENU.DEVICE_FIRMWARE',
        route: '/devices-firmware',
        subject: [Models.BatchFirmwareUpdate],
        position: 1,
      }),
      new SidenavItem({
        svgIcon: 'point',
        name: 'MENU.INSTALLATIONS_ADM',
        route: '/installation-adm',
        subject: [Models.Devices],
        position: 2,
      }),
    ],
  }),
  new SidenavItem({
    svgIcon: 'star',
    name: 'MENU.MEDIA',
    subject: [Models.Stories],
    route: '',
    position: 5,
    subItems: [
      new SidenavItem({
        svgIcon: 'point',
        subject: [Models.Stories],
        name: 'MENU.STORIES_LIST',
        route: '/stories',
        position: 0,
      }),
    ],
  }),
  new SidenavItem({
    svgIcon: 'ring-medium',
    name: 'MENU.NOTIFICATIONS',
    subject: [Models.Notifications],
    route: '',
    position: 6,
    subItems: [
      new SidenavItem({
        svgIcon: 'point',
        subject: [Models.Notifications],
        name: 'MENU.NOTIFICATION_HISTORY',
        route: '/notifications-history',
        position: 0,
      }),
      new SidenavItem({
        svgIcon: 'point',
        subject: [Models.NotificationTemplates],
        name: 'MENU.NOTIFICATION_TEMPLATES',
        route: '/notifications-templates',
        position: 1,
      }),
    ],
  }),
  new SidenavItem({
    svgIcon: 'settings',
    name: 'MENU.SYSTEM',
    subject: [Models.Users],
    route: '',
    position: 7,
    subItems: [
      new SidenavItem({
        svgIcon: 'point',
        subject: [Models.Users],
        name: 'MENU.USERS',
        route: '/users',
        position: 0,
      }),
    ],
  }),
];
